import { useEffect } from "react";

const PAGE_SEO = {
  "/": {
    title: "NG Industries | Industrial Textile Solutions | PVC Walls & Curtains Australia",
    description: "Australia's trusted manufacturer of industrial textile solutions. Custom PVC warehouse dividing walls, industrial sliding curtains, heavy-duty covers, and weather protection systems. Australian made in Western Australia.",
  },
  "/about": {
    title: "About NG Industries | Australian Industrial Textile Manufacturer",
    description: "Since 1998, NG Industries has been Western Australia's leading manufacturer of industrial textile solutions. Custom PVC walls, curtains, and covers engineered for performance.",
  },
  "/products": {
    title: "Industrial Textile Products | PVC Walls, Curtains, Covers | NG Industries",
    description: "Commercial-grade PVC warehouse dividing walls, industrial sliding curtains, welding screens, weather protection systems, and custom textile solutions. Australian made.",
  },
  "/industries": {
    title: "Industries We Serve | Warehousing, Mining, Manufacturing | NG Industries",
    description: "Trusted by warehousing, logistics, mining, manufacturing, agriculture, and construction industries across Australia. Custom industrial textile solutions for every sector.",
  },
  "/quote": {
    title: "Request a Quote | Custom PVC Walls & Industrial Curtains | NG Industries",
    description: "Get a free, no-obligation quote for custom PVC warehouse dividing walls, industrial curtains, covers, and textile solutions. Fast turnaround, Australian made.",
  },
  "/contact": {
    title: "Contact NG Industries | Industrial Textile Solutions Perth WA",
    description: "Contact NG Industries at 8 Blamey Place, O'Connor WA. Call +61 413 136 160 or email office@ngindustries.com.au for industrial textile enquiries.",
  },
};

export default function SEOHead({ pathname }) {
  useEffect(() => {
    const seo = PAGE_SEO[pathname] || PAGE_SEO["/"];
    document.title = seo.title;

    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute("content", seo.description);

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute("content", seo.title);

    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute("content", seo.description);

    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute("content", `https://ngindustries.com.au${pathname}`);

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute("href", `https://ngindustries.com.au${pathname}`);
  }, [pathname]);

  return null;
}
